var _style, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgN4(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 35 30",
    style: {
      enableBackground: "new 0 0 35 30"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#5A00CA;}\r\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M30.7,15.6c0-2.4-0.7-4.8-2-6.8c-1.3-2-3.1-3.6-5.3-4.6c-2.2-1-4.6-1.4-7-1C14,3.4,11.7,4.5,9.9,6 C8.1,7.6,6.7,9.6,6,11.9C5.3,14.2,5.3,16.7,6,19c0.7,2.3,2,4.4,3.8,6s4,2.6,6.4,3v-8.8h-3.2v-3.6h3.2v-2.8c0-3.2,1.9-4.9,4.8-4.9 c0.9,0,1.9,0.1,2.8,0.2v3.1h-1.6c-1.6,0-2,1-2,2v2.4h3.5L23,19.2H20V28c3-0.5,5.6-2,7.6-4.3C29.6,21.5,30.7,18.6,30.7,15.6z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgN4);
export default __webpack_public_path__ + "static/media/n4.93c69fb2b5e6ee2659c3d6c310b3cca4.svg";
export { ForwardRef as ReactComponent };